import React from 'react';
import {StyleSheet, View, Text, Image, Dimensions} from 'react-native';
import CommonStyle from '../StyleSheets/CommonStyleSheet';
import emptyMsgIcon from '../assets/emptyMsgIcon.png';
import colors from '../HelperClasses/AppColor';
import emptyAccont from '../assets/emptyAccont.png';
import emptyListing from '../assets/emptyListing.png';
import emptyPromo from '../assets/emptyPromo.png';
import emptyCollection from '../assets/emptyCollection.png';
import TextTitleStyleSheet from '../StyleSheets/TextTitleStyleSheet';
import emptyCoupon from '../assets/emptyCoupon.png';

const windowWidth = Dimensions.get('window').width;
const windowHeight = Dimensions.get('window').height;

const ComponentErrorFetch = () => {
  return (
    <View style={styles.imageMainStyle}>
      <View
        style={{
          maxWidth: '500px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <Image
          style={{
            width: 200,
            height: 150,
            marginTop: 100,
          }}
          source={emptyMsgIcon}
          resizeMode={'contain'}
        />
        <View style={{height: 0}} />

        <View style={{height: 10}} />
        <Text style={[CommonStyle.subTitleStyle, {textAlign: 'center'}]}>
          This content isn't loading right now. Check your connection and
          refresh the page. If the network is stable but content still doesn't
          load, come back in a few moments when service is restored. Your data
          remains secure and will be available once connectivity returns.
        </Text>
      </View>
    </View>
  );
};

export default ComponentErrorFetch;

const styles = StyleSheet.create({
  mainStyle: {
    position: 'absolute',
    top: 100,
    left: 0,
    height: '100%',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  imageMainStyle: {
    position: 'relative',
    left: 0,
    height: '80%',
    width: '100%',
    alignItems: 'center',
  },
});
